<template>
    <div class="box">
      <div class="box-one">
        <div class="context">
            <div class="context-one gsap-box">
               繁淼科技合作商招募
            </div>
            <img class="context-two gsap-box" src="../../../assets/home-line.png" alt="" srcset="">
            <div class="context-three">
               <div class="context-three-item gsap-box">
                  <div></div>
                  <div>全程助力</div>
               </div>
               <div class="context-three-item gsap-box">
                  <div></div>
                  <div>合作共赢</div>
               </div>
            </div>
            <div class="context-four gsap-box" @click="entBtn">
               <span>立即入驻</span>
            </div>
            <div @click="conditionBtn" class="context-five gsap-box" style="cursor: pointer;">
               <img src="../../../assets/question.png" alt="">
               <span>入驻条件</span>
            </div>
        </div>
      </div>
      <div class="box-two">
         <div class="title gsap-title">
            为什么选择我们？
         </div>
         <div class="context">
            <div class="context-item gsap-box2">
               <img src="../../../assets/home-01.png" class="item-num" alt="" srcset="">
               <div class="item-text">
                  <div>品牌优势</div>
                  <div>Brand advantage</div>
               </div>
            </div>
            <div class="context-line"></div>
            <div class="context-item gsap-box2">
               <img src="../../../assets/home-02.png" class="item-num" alt="" srcset="">
               <div class="item-text">
                  <div>产品优势</div>
                  <div>Product advantage</div>
               </div>
            </div>
            <div class="context-line"></div>
            <div class="context-item gsap-box2">
               <img src="../../../assets/home-03.png" class="item-num" alt="" srcset="">
               <div class="item-text">
                  <div>供应链优势</div>
                  <div>Supply chain advanta</div>
               </div>
            </div>
            <div class="context-line"></div>
            <div class="context-item gsap-box2">
               <img src="../../../assets/home-04.png" class="item-num" alt="" srcset="">
               <div class="item-text">
                  <div>团队优势</div>
                  <div>Team advantage</div>
               </div>
            </div>
         </div>
      </div>
    </div>
</template>
<script>
   import { gsap } from 'gsap'
   export default{
      mounted(){
         // 不想要动画将下面代码注释即可
         // console.log((window.innerWidth || document.documentElement.clientWidth))
         gsap.from('.gsap-box',{
            x:-(window.innerWidth || document.documentElement.clientWidth),
            duration:1,
            stagger: 0.1, // 按顺序延迟执行每个元素的动画
            ease: "power2.out"
         })
         gsap.from('.gsap-box2',{
            x:-(window.innerWidth || document.documentElement.clientWidth),
            duration:1,
            stagger: 0.5, // 按顺序延迟执行每个元素的动画
            ease: "power2.out"
         })
         gsap.from('.gsap-title',{
            opacity:0,
            duration:3,
            ease: "power2.out"
         })
      },
      methods:{
         //入住条件
         conditionBtn(){
            this.$router.push('/condition')
         },
         //立刻入驻
         entBtn(){
            this.$router.push('/profile')
         }
      }
   }
</script>
<style lang="scss" scoped>
   .box{
       width:100%;
       .box-one{
         width: 100%;
         height: 640px;
         background:url('./../../../assets/home-bg.png') no-repeat;
         background-size:100% 100%;
         // background-attachment: fixed;
         box-sizing: border-box;
         position: relative;
         padding-top: 155px;
         .context{
            width: 1200px;
            height: 100%;
            margin: 0 auto;
            // position: absolute;
            // top: 155px;
            // left: 347px;
            .context-one{
               font-size: 48px;
               font-family: Alibaba_Bold;
               color: #FFFFFF;
               line-height: 67px;
               margin-bottom: 20px;
            }
            .context-two{
               margin-bottom: 40px;
            }
            .context-three{
               display: flex;
               margin-bottom: 50px;
               .context-three-item{
                  display: flex;
                  div:nth-child(1){
                     margin-top: 11px;
                     width: 8px;
                     height: 8px;
                     border-radius: 50%;
                     background: rgba(255,255,255,0.9);
                     margin-right: 10px;
                  }
                  div:nth-child(2){
                     font-size: 20px;
                     font-family: Alibaba_Midum;
                     color: #FFFFFF;
                     line-height: 28px;
                     margin: 0;
                     margin-right: 35px;
                  }
               }
            }
            .context-four{
               margin-bottom: 30px;
               width: 176px;
               height: 58px;
               background: #367CFF;
               border-radius: 34px;
               display: flex;
               align-items: center;
               justify-content: center;
               cursor: pointer;
               span{
                  font-size: 24px;
                  font-family: Alibaba_Midum;
                  color: #FFFFFF;
                  line-height: 33px;
               }
               &:hover{
                  opacity: .8;
               }
            }
            .context-five{
               display: flex;
               align-items: center;
               opacity: .7;
               span{
                  margin-left: 7px;
                  font-size: 14px;
                  font-family: Alibaba_Regular;
                  font-weight: 400;
                  color: #FFFFFF;
                  line-height: 20px;
               }
            }
         }
       }
       .box-two{
         width: 100%;
         height: 172px;
         background: #21293E;
         box-sizing: border-box;
         padding-top: 30px;
         .title{
            height: 33px;
            font-size: 24px;
            font-family: Alibaba_Bold;
            color: #FFFFFF;
            line-height: 33px;
            display: flex;
            justify-content: center;
            margin-bottom: 33px;
         }
         .context{
            display: flex;
            justify-content: center;
            .context-item{
               display: flex;
               .item-num{
                  margin-right: 8px;
               }
               .item-text{
                  
                  div:nth-child(1){
                     font-size: 18px;
                     font-family: Alibaba_Midum;
                     font-weight: 600;
                     color: #FFFFFF;
                     line-height: 25px;
                  }
                  div:nth-child(2){
                     font-size: 12px;
                     font-family: Alibaba_Regular;
                     font-weight: 400;
                     color: #FFFFFF;
                     line-height: 17px;
                     opacity: .5;
                  }
               }
            }
            .context-line{
               width: 1px;
               height: 26px;
               background: #FFFFFF;
               opacity: 0.4;
               margin-left: 90px;
               margin-top: 10px;
               margin-right: 68px;
            }
         }
       }
   }
</style>